import { useLocation, useParams } from 'react-router-dom';
import * as ROUTES from 'constants/routes.js';
import {
  REDIRECT_ORG_BASE_ROUTE,
  SHORTCUTS_ROUTES,
  SIGN_OUT,
  SUPERADMIN_ROUTES,
  UNAUTHENTICATED_ROUTES,
  CLIENT_BASE,
} from 'constants/routes.js';

const RESERVED_WORDS = [
  ...new Set(
    [...SUPERADMIN_ROUTES, ...SHORTCUTS_ROUTES, ...UNAUTHENTICATED_ROUTES, SIGN_OUT, REDIRECT_ORG_BASE_ROUTE, CLIENT_BASE].map(
      (route) => route.split('/')[1],
    ),
  ),
];

const doesMatchReservedWords = (route) => RESERVED_WORDS.some((word) => word === route);

export const isOrgId = (orgIdString = '') => !doesMatchReservedWords(orgIdString);

export const getOrgIdFromPathname = (pathname) => {
  const pathNameParts = pathname.split('/');
  const orgIdPart = pathNameParts[1] === ROUTES.REDIRECT_ORG_PREFIX ? pathNameParts[2] : pathNameParts[1];

  return isOrgId(orgIdPart) ? orgIdPart : null;
};

const useOrgId = () => {
  const { pathname } = useLocation();
  const { orgId: paramsOrgId } = useParams();

  if (paramsOrgId) return paramsOrgId;

  if (getOrgIdFromPathname(pathname)) return getOrgIdFromPathname(pathname);

  return undefined;
};

export default useOrgId;
